import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M6 5V13H16.17L13.59 10.41L15 9L20 14L15 19L13.59 17.59L16.17 15H4V5H6Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "SubRight"
);
